<div id="reorder-products-pop" class="modal in popup-comp cart-popup" role="dialog" data-backdrop="static"
  style="display: block">
  <div class="modal-dialog reorder-dialog">
    <div class="modal-content">
      <div class="modal-header relative">
        <h4 class="modal-title-top20">Reorder Products</h4>
        <div class="cls-btn" (click)="closeModal()">
          <img [src]="'/icons/'+baseSiteId+'/close.svg'" />
        </div>
      </div>
      <div class="modal-body">
        <p class="reorder-prodcts-guide-txt">
          Indicate the units you need for each product, and then add them to
          your cart.
        </p>
        <div class="row row-20 product-details" id="leftCont-rightNav">
          <div class="col-xs-12 col-sm-12 col-md-12 left-section sm-bd-b0 p0" style="min-height: auto">
            <form id="sanofiReorderForm">
              <div class="slimScrollDiv">
                <ul class="checkout-details checkout-reorder">
                  @for (reorderData of reoderProductList; track reorderData; let i = $index) {
                    <li class="cart-block cart-view-block">
                      <div class="row row-20">
                        <div class="col-xs-4 col-sm-1 col-md-1 col-lg-1 pr0 cart_print">
                          <a href="javascript:void(0)" class="cart_title" (click)="navigatePDP(reorderData?.code)">
                            <div>
                              <img class="image-align" [src]="getImage(reorderData)">
                            </div>
                          </a>
                        </div>
                        <div class="col-xs-8 col-sm-5 col-md-5 col-lg-5 data-pad">
                          <div class="checkout-data ml-3">
                            <a class="cart_title" (click)="navigatePDP(reorderData?.code)">
                              <div>
                                <h2 [innerHTML]="reorderData?.baseProductName"></h2>
                              </div>
                            </a>
                            <div class="product_txt_cart product_txt_bt">
                              <p>
                                <a class="cart_title" [innerHTML]="reorderData?.baseProductDescription">
                                </a>
                              </p>
                            </div>
                            <p>
                              {{reorderData?.variantProductDescription}}
                            </p>
                            <p><span class="prodCode">{{reorderData?.code}}</span> | {{reorderData?.manufacturer}}</p>
                            @if (reorderData?.contract && reorderData?.contract.length > 0) {
                              <div>
                                <span><b>Contract group: </b></span>
                                @if (reorderData?.contract.length == 1) {
                                  <span
                                  >{{reorderData?.contract[0]?.contractDesc}}</span>
                                }
                                @if (reorderData?.contract.length > 1) {
                                  <div>
                                    <ng-select [items]="reorderData?.contract" [searchable]="false" [clearable]="false"
                                      name="{{'contractId' + reorderData?.code}}" bindLabel="contractDesc"
                                      bindValue="contractId" placeholder="Select Contract Group"
                                      [(ngModel)]="reorderData.selectedContractId" class="dropdown-contractGroup"
                                      (change)="reorderData.selectedContractGroup = $event">
                                    </ng-select>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        </div>
                        <div class="col-xs-6 col-sm-3 col-md-2 col-lg-3">
                          <div class="product-price">
                            <h6>Your price</h6>
                            <section class="price-total">
                              @if (!reorderData?.price && !reorderData?.contract) {
                                <span>$--</span>
                              }
                              @if (reorderData?.price && !reorderData?.contract) {
                                <span>
                                  <span>{{reorderData?.price?.value | currency}}</span> {{reorderData?.price?.currencyIso}}
                                  @if (reorderData?.priceDetailsObj?.fexciseTax?.value) {
                                    <div class="federal-tax">
                                      {{reorderData?.priceDetailsObj?.fexciseTax?.value |
                                      currency}}/package Federal Excise Tax
                                    will be added.</div>
                                  }
                                </span>
                              }
                              @if (!reorderData?.price && reorderData?.contract) {
                                <span>
                                  {{getContractPrice(reorderData.selectedContractGroup)}}
                                  @if (reorderData?.contract && reorderData.selectedContractGroup?.contractPrice?.formattedValue &&
                                    reorderData?.priceDetailsObj?.fexciseTax?.value) {
                                    <div class="federal-tax">
                                      {{reorderData?.priceDetailsObj?.fexciseTax?.value | currency}}/package Federal Excise
                                    Tax will be added.</div>
                                  }
                                </span>
                              }
                            </section>
                          </div>
                        </div>
                        <div class="col-xs-5 col-sm-3 col-md-3 col-lg-3 cart-unitPrice">
                          @if (
                            userDetails &&
                            (reorderData?.flu ? reorderData.shipNow?.toLowerCase() == 'on' : true)
                            && prodAvailableForOrder(reorderData) &&
                            (isFormularyCustomer ? reorderData.formularyProduct : true) &&
                            (reorderData?.yellowFever ? isYFauthorized : true)
                            ) {
                            <div class="unitCount-comp">
                              <div class="addUnits-head bold-12 units-title">
                                Units
                              </div>
                              <div class="add-units">
                                <span class="minusQty focus timedsbld">
                                  <img [src]="'/icons/'+baseSiteId+'/less_new.svg'" aria-hidden="true"
                                    [ngClass]="{'disabled-image': number.value == '0' || number.value == ''}"
                                    id="{{ 'unitMinus' + reorderData?.code }}" alt="minus_icon"
                                    (click)="performQuantityComputation(2,reorderData?.code,reorderData);" />
                                </span>
                                <input type="number" #number [value]="0" class="prod-quantity text-center"
                                  (change)="disabled = false"
                                  (keyup)="performQuantityComputation(null,reorderData?.code,reorderData);"
                                  id="{{ 'prodQuantity' + reorderData?.code }}" appNoMouseScroll />
                                <span class="plusQty focus" tabindex="0">
                                  <img [src]="'/icons/'+baseSiteId+'/more.svg'" aria-hidden="true"
                                    id="{{ 'unitPlus' + reorderData?.code }}" alt="plus_icon"
                                    (click)="performQuantityComputation(1,reorderData?.code,reorderData);" />
                                </span>
                              </div>
                              <div class="count-total">
                                <span data-multiply="10" id="{{ 'noOfDoses' + reorderData?.code }}">
                                  {{unitValue(reorderData?.code) ? reorderData?.quantityPerUnit+' '+reorderData?.uom : '0'+'
                                  '+reorderData?.uom}}
                                </span>
                              </div>
                            </div>
                          }
                          <!-- For non-formulary product  -->
                          @if (
                            userDetails &&
                            isFormularyCustomer &&
                            !reorderData?.formularyProduct
                            ) {
                            <div class="formulary-section">
                              <div>
                                <span>This product is not in your formulary.</span>
                              </div>
                              <div>
                                <a [ngbPopover]="popSaveContent" placement="top" #s3="ngbPopover" triggers="manual"
                                popoverClass="savedordermini-popover" (click)="openPopup(s3)">View details</a>
                              </div>
                              <ng-template #popSaveContent>
                                <div class="mb-3">
                                  This product request is outside your approved formulary and cannot be ordered at this
                                  time. Please talk to your Contract Administrator/Purchasing Department to add products to
                                  your approved formulary.
                                </div>
                                <a (click)="navigateFormulary()">View your current approved products</a>
                                <div class="mt-2 mb-3">
                                  For more information contact @if (baseSiteId == 'vsh') {
                                  <span>1-800-VACCINE
                                  (1-800-822-2463)</span>
                                  }@if (baseSiteId == 'vax') {
                                  <span>1-800-752-9338</span>
                                }
                              </div>
                            </ng-template>
                          </div>
                        }
                        @if (
                          userDetails &&
                          (isFormularyCustomer ? reorderData.formularyProduct : true) &&
                          (reorderData?.yellowFever && !isYFauthorized)
                          ) {
                          <div class="col-sm-5 p-0" [ngStyle]="{'font-size': '14px'}">
                            <span>Our records indicate that you are not authorized by your State Health Department to
                              purchase Yellow Fever vaccine. To purchase Yellow Fever vaccine, your practice must be
                              certified by your State Health Department, and Sanofi Pasteur must receive proof of this
                              certification directly from the issuing State Health Department. Please call Customer
                              Service at {{ baseSiteId == 'vsh' ? '1-800-VACCINE (1-800-822-2463)' : '1-800-752-9338'}} to
                              obtain contact information for the appropriate party at your State Health Department who can
                            assist you with this process.</span>
                          </div>
                        }
                        <!-- ------------- -  -->
                        <!-- Restriction Errors -->
                        @if (userDetails &&
                          !prodAvailableForOrder(reorderData) &&
                          (isFormularyCustomer ? reorderData.formularyProduct : true) &&
                          (reorderData?.yellowFever ? isYFauthorized : true)
                          ) {
                          <div>
                            @for (item of errorMessages(reorderData); track item) {
                              <p [ngStyle]="{ color: '#CA0000', 'font-size.px': '14' }">
                                {{ item }}
                              </p>
                            }
                          </div>
                        }
                        <!-- --------------- -->
                      </div>
                    </div>
                  </li>
                }
              </ul>
            </div>
          </form>
        </div>
      </div>
      <div class="reorder-button-container d-flex flex-column align-items-center">
        <button type="button" class="btn-primary mb-2" [disabled]="disabled || checkoutFlag || blockOrder"
          data-dismiss="modal" (click)="addToCart('checkout')">
          @if (checkoutFlag) {
            <i class="fa fa-spinner fa-spin"></i>
          }
          Checkout
        </button>
        <button type="button" class="btn-secondary mb-1" data-dismiss="modal"
          [disabled]="disabled || addToCartFlag || blockOrder" (click)="addToCart('addToCart')">
          @if (addToCartFlag) {
            <i class="fa fa-spinner fa-spin"></i>
          }
          Add to cart
        </button>
      </div>
    </div>
  </div>
</div>
</div>
